export default "__VITE_ASSET__D4BfdbPP__"